/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Mapping_Results_HeadingInputs */

const en_story_bank_mapping_results_heading = /** @type {(inputs: Story_Bank_Mapping_Results_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapping Results`)
};

const de_story_bank_mapping_results_heading = /** @type {(inputs: Story_Bank_Mapping_Results_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapping Results`)
};

const fr_story_bank_mapping_results_heading = /** @type {(inputs: Story_Bank_Mapping_Results_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapping Results`)
};

const es_story_bank_mapping_results_heading = /** @type {(inputs: Story_Bank_Mapping_Results_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapping Results`)
};

const it_story_bank_mapping_results_heading = /** @type {(inputs: Story_Bank_Mapping_Results_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapping Results`)
};

const nl_story_bank_mapping_results_heading = /** @type {(inputs: Story_Bank_Mapping_Results_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapping Results`)
};

const pl_story_bank_mapping_results_heading = /** @type {(inputs: Story_Bank_Mapping_Results_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapping Results`)
};

const fi_story_bank_mapping_results_heading = /** @type {(inputs: Story_Bank_Mapping_Results_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapping Results`)
};

const da_story_bank_mapping_results_heading = /** @type {(inputs: Story_Bank_Mapping_Results_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapping Results`)
};

const sv_story_bank_mapping_results_heading = /** @type {(inputs: Story_Bank_Mapping_Results_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapping Results`)
};

/**
* | output |
* | --- |
* | "Mapping Results" |
*
* @param {Story_Bank_Mapping_Results_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_mapping_results_heading = /** @type {((inputs?: Story_Bank_Mapping_Results_HeadingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Mapping_Results_HeadingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_mapping_results_heading(inputs)
	if (locale === "fr") return fr_story_bank_mapping_results_heading(inputs)
	if (locale === "es") return es_story_bank_mapping_results_heading(inputs)
	if (locale === "it") return it_story_bank_mapping_results_heading(inputs)
	if (locale === "nl") return nl_story_bank_mapping_results_heading(inputs)
	if (locale === "pl") return pl_story_bank_mapping_results_heading(inputs)
	if (locale === "fi") return fi_story_bank_mapping_results_heading(inputs)
	if (locale === "da") return da_story_bank_mapping_results_heading(inputs)
	if (locale === "sv") return sv_story_bank_mapping_results_heading(inputs)
	return en_story_bank_mapping_results_heading(inputs)
});